export default __webpack_public_path__ + "static/Image045-1_small-646c3c55b655475ce425a4425e9a5d0a.png";